import { registerEnumType } from 'type-graphql'

export enum CreditPurchaseStatusEnum {
  Pending = 'Pending',
  Paid = 'Paid',
}

registerEnumType(CreditPurchaseStatusEnum, {
  name: 'CreditPurchaseStatusEnum',
  description: 'Lifecycle of a CreditPurchase — Pending until settlement claims it, Paid once credits have been granted.',
})
